import {useState, useEffect} from 'react';
import { Divider, Grid2 as Grid, Typography, Alert, Stack, FormControl, InputLabel, Select, MenuItem, CircularProgress} from '@mui/material';
import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { useErrorBoundary } from 'react-error-boundary';

import YtdReport from '../../../types/reports/ytdReport';
import YearToDateReportsTable from './YearToDateReportsTable';
import ReportListExportSession from './ReportListExportSection';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';

const StatePartyReports = (): JSX.Element => {

    document.title = 'OCPF - State Party Committee Reports';

    const { showBoundary } = useErrorBoundary();  
    const dropDownYears = Array.from(new Array(10), (val, index) => new Date().getFullYear() - index);
    const [isLoading, setIsLoading] = useState(true);
    const [tableRows, setRows] = useState<YtdReport[]>();
    const [reportsSummary, setReportsSummary] = useState('No reports found.');
    const [reportYear, setReportYear] = useState(new Date().getMonth()===0?new Date().getFullYear()-1: new Date().getFullYear());
    const [excelExportUrl, setExcelExportUrl] = useState('');
    const [txtExportUrl, setTxtExportUrl] = useState('');


    useEffect(() => {
        getStatePartyReportList();
      }, [reportYear])

      const getStatePartyReportList = async () => {

        setExcelExportUrl(`${process.env.REACT_APP_API_BASE_URL}/reports/stateparties/excelOutput/${reportYear}`);
        setTxtExportUrl(`${process.env.REACT_APP_API_BASE_URL}/reports/stateparties/textOutput/${reportYear}`);

        try{
          await fetch(`${process.env.REACT_APP_API_BASE_URL}/reports/stateparties/${reportYear}`)
          .then(result => {
            if (!result.ok) {
              showBoundary(new Error('Failed to get legislative full year reports.'));
            }
            return result.json();
          })
          .then(result => {
            let count = result.length;
            if (count === 0){
                setReportsSummary("No reports found.");
                setRows([]);
            }
            else{
                setReportsSummary(`Viewing 1 through ${count} of ${count} reports`);
                setRows(result);
            }
            setIsLoading(false);
          });
        }catch(error){
            console.error('Uncaught Error:', error);
            showBoundary(new Error(`${error}`));
        }
      }
      
      const updateReporYear = (event: any) => {
        setReportYear(event.target.value);
      };

    return (
      <Main>
        <Container>
        <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            gutterBottom
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            marginBottom={2}
            >
            State Party Committee Reports
        </Typography>
        <Divider/>
        <Grid container marginBottom={2} marginTop={3}>
          <Grid size={{ xs: 12, md: 10 }}>
            <Stack direction={"row"} spacing={1} 
                sx={{ mb: 1}}
                >
                 <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="year-id">Year</InputLabel>
                    <Select 
                        labelId="year-id"
                        id="year-select"
                        aria-labelledby='year-id'
                        sx={{fontSize: 'smaller'}} 
                        label="Report Year"
                        defaultValue={reportYear}
                        onChange={updateReporYear}
                    >
                    {
                        dropDownYears.map((year) =>
                            <MenuItem value={year} key={year} >{year}</MenuItem>
                        )
                    }
                    </Select>
                </FormControl>
            </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
            <ReportListExportSession excelExportUrl={excelExportUrl} txtExportUrl={txtExportUrl}></ReportListExportSession>
        </Grid>
        <Grid size={11.5}>
            <Alert icon={false} severity="info"
            sx={{ 
                display: 'flex', 
                justifyContent: 'center',
                '.MuiAlert-message': { 
                padding: '4px',
                } 
            }}
        >
            {reportsSummary}
            </Alert>
        </Grid>
      </Grid>
       {/*report table*/}
        <YearToDateReportsTable tableRows={tableRows} isCandidate={false}></YearToDateReportsTable>
       {/*loading indicator*/}
       <CircularProgress
          aria-label='Loading'
            size={50}
            className={isLoading? "": "hidden"}
            sx={{
              position: "fixed",
              left: "50%",
              top: "20%",
              transform: "translate(-50%, -50%)",
              zIndex: 2
             }}
        />
    </Container>
    </Main>
  );
};

export default StatePartyReports;
